// components/model/ModelSkeleton.jsx
import React from 'react';

const ModelSkeleton = ({ isDarkMode }) => {
  return (
    <div className="container px-4 py-8 mx-auto max-w-7xl">
      {/* Header Skeleton - Using same style as CategoryHeader */}
      <div className="mb-4">
        <div className={`h-6 w-48 rounded-lg mb-2 ${
          isDarkMode ? 'bg-gray-800' : 'bg-gray-200'
        } animate-pulse`}></div>
        <div className={`h-4 w-64 rounded ${
          isDarkMode ? 'bg-gray-800' : 'bg-gray-200'
        } animate-pulse`}></div>
      </div>

      {/* Grid Skeleton */}
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10">
        {[...Array(20)].map((_, index) => (
          <div
            key={index}
            className={`rounded-lg overflow-hidden ${
              isDarkMode 
                ? 'bg-gray-800' 
                : 'bg-white shadow-[0_2px_6px_rgba(0,0,0,0.06)]'
            } animate-pulse`}
          >
            {/* Image Area */}
            <div className="pt-3 pb-0.5 px-2">
              <div className="flex items-center justify-center w-full aspect-square">
                <div className={`w-2/3 h-2/3 ${
                  isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
                }`}></div>
              </div>
            </div>

            {/* Text Area */}
            <div className="px-1 pb-2 text-center">
              <div className={`h-3 w-16 mx-auto rounded mb-1 ${
                isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
              }`}></div>
              <div className={`h-2 w-12 mx-auto rounded ${
                isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
              }`}></div>
            </div>

            {/* Bottom Accent Line */}
            {!isDarkMode && (
              <div className="h-0.5 w-full bg-gray-100" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModelSkeleton;